"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dealer = void 0;
const CardFinder_1 = require("./CardFinder");
const LogHelper_1 = require("./LogHelper");
class Dealer {
    constructor() {
        this.deck = [];
        this.preludeDeck = [];
        this.discarded = [];
        this.discardedPreludes = [];
        this.corporationCards = [];
        this.discardedCorporations = [];
        this.leaderDeck = [];
    }
    static newInstance(loader) {
        const dealer = new Dealer();
        dealer.deck = Dealer.shuffle(loader.getProjectCards());
        dealer.preludeDeck = Dealer.shuffle(loader.getPreludeCards());
        dealer.corporationCards = loader.getCorporationCards();
        dealer.leaderDeck = Dealer.shuffle(loader.getLeaderCards());
        return dealer;
    }
    static shuffle(cards) {
        const deck = [];
        const copy = cards.slice();
        while (copy.length) {
            deck.push(copy.splice(Math.floor(Math.random() * copy.length), 1)[0]);
        }
        return deck;
    }
    discard(card) {
        this.discarded.push(card);
    }
    discardCorporation(card) {
        this.discardedCorporations.push(card);
    }
    discardPrelude(card) {
        this.discardedPreludes.push(card);
    }
    dealCard(game, isResearchPhase = false) {
        if (this.deck.length === 0) {
            game.log('The discard pile has been shuffled to form a new deck.');
            this.deck = Dealer.shuffle(this.discarded);
            this.discarded = [];
        }
        let result;
        if (isResearchPhase) {
            result = this.deck.shift();
        }
        else {
            result = this.deck.pop();
        }
        if (result === undefined) {
            throw 'Unexpected empty deck';
        }
        return result;
    }
    drawProjectCardsByCondition(game, total, include) {
        const result = [];
        const discardedCards = new Set();
        while (result.length < total) {
            if (discardedCards.size >= this.getDeckSize() + this.getDiscardedSize()) {
                game.log('discarded every card without match');
                break;
            }
            const projectCard = this.dealCard(game);
            if (include(projectCard)) {
                result.push(projectCard);
            }
            else {
                discardedCards.add(projectCard.name);
                this.discard(projectCard);
            }
        }
        if (discardedCards.size > 0) {
            LogHelper_1.LogHelper.logDiscardedCards(game, Array.from(discardedCards));
        }
        return result;
    }
    dealPreludeCard(game) {
        if (this.preludeDeck.length === 0) {
            game.log('The preludes discard pile has been shuffled to form a new deck.');
            this.preludeDeck = Dealer.shuffle(this.discardedPreludes);
            this.discardedPreludes = [];
        }
        const result = this.preludeDeck.pop();
        if (result === undefined) {
            throw 'Unexpected empty prelude deck';
        }
        return result;
    }
    dealLeaderCard() {
        const result = this.leaderDeck.pop();
        if (result === undefined) {
            throw 'Unexpected empty leader deck';
        }
        return result;
    }
    dealCorporationCard() {
        if (this.corporationCards.length === 0) {
            this.corporationCards = Dealer.shuffle(this.discardedCorporations);
            this.discardedCorporations = [];
        }
        const result = this.corporationCards.pop();
        if (result === undefined) {
            throw 'Unexpected empty corporation deck';
        }
        return result;
    }
    getDeckSize() {
        return this.deck.length;
    }
    getDiscardedSize() {
        return this.discarded.length;
    }
    static deserialize(d) {
        const dealer = new Dealer();
        const cardFinder = new CardFinder_1.CardFinder();
        dealer.corporationCards = cardFinder.corporationCardsFromJSON(d.corporationCards);
        dealer.discardedCorporations = cardFinder.corporationCardsFromJSON(d.discardedCorporations);
        dealer.deck = cardFinder.cardsFromJSON(d.deck);
        dealer.discarded = cardFinder.cardsFromJSON(d.discarded);
        dealer.discardedPreludes = cardFinder.cardsFromJSON(d.discardedPreludes);
        dealer.preludeDeck = cardFinder.cardsFromJSON(d.preludeDeck);
        dealer.leaderDeck = cardFinder.cardsFromJSON(d.leaderDeck);
        return dealer;
    }
    serialize() {
        return {
            corporationCards: this.corporationCards.map((c) => c.name),
            discardedCorporations: this.discardedCorporations.map((c) => c.name),
            deck: this.deck.map((c) => c.name),
            discarded: this.discarded.map((c) => c.name),
            discardedPreludes: this.discardedPreludes.map((c) => c.name),
            preludeDeck: this.preludeDeck.map((c) => c.name),
            leaderDeck: this.leaderDeck.map((c) => c.name),
        };
    }
}
exports.Dealer = Dealer;
//# sourceMappingURL=Dealer.js.map